/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@import url(https://fonts.googleapis.com/css?family=Open+Sans:400,600,700,800&display=swap);.page-checksign[_ngcontent-%COMP%]{padding:7px 0 30px}h2[_ngcontent-%COMP%]{margin-bottom:45px}.verify-code[_ngcontent-%COMP%]{margin-top:45px}.page-breadcrumb[_ngcontent-%COMP%]{margin-top:15px;margin-bottom:10px}.form[_ngcontent-%COMP%]{text-align:center}"];
export { styles as styles };
